import React, { createContext, useContext } from 'react';

const BatchPaymentContext = createContext(undefined);

export const BatchPaymentProvider = ({ children, value }) => {
    return <BatchPaymentContext.Provider value={value}>{children}</BatchPaymentContext.Provider>;
};

export const useBatchPaymentContext = () => {
    const context = useContext(BatchPaymentContext);
    if (context === undefined) {
        throw new Error('useBatchPaymentContext 必須在 BatchPaymentProvider 中使用');
    }
    return context;
};
